import type {
  CanvasCapture,
  CanvasSession,
  Persona,
  ResearchSessionStatus,
} from '@repo/contracts';

import { SessionCard } from './session-card';

/** Each room's first screen, by session id — its cover on a card or row. */
export function coversBySession(
  captures: CanvasCapture[],
): Map<string, CanvasCapture> {
  const coverOf = new Map<string, CanvasCapture>();
  for (const capture of [...captures].sort((a, b) => a.order - b.order)) {
    if (!coverOf.has(capture.sessionId))
      coverOf.set(capture.sessionId, capture);
  }
  return coverOf;
}

/**
 * Every room, newest first, as cards.
 */
export function SessionGrid({
  captures,
  panels,
  sessions,
  statuses,
}: {
  captures: CanvasCapture[];
  /** Each site's panel, by project id. */
  panels: Map<string, Persona[]>;
  sessions: CanvasSession[];
  statuses: ResearchSessionStatus[];
}) {
  const statusOf = new Map(
    statuses.map((status) => [status.sessionId, status]),
  );
  const coverOf = coversBySession(captures);

  return (
    <ul
      aria-label="Rooms"
      className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
    >
      {sessions.map((session, index) => (
        <SessionCard
          capture={coverOf.get(session.id)}
          index={index}
          key={session.id}
          panel={panels.get(session.projectId) ?? []}
          session={session}
          status={statusOf.get(session.id)}
        />
      ))}
    </ul>
  );
}
